import { ROUTES, callAPI } from "../API/index";

// -----------------------------------------------
// Beacon
// -----------------------------------------------
export const fetchBeaconList = (corp_no) => {
    /**
     * 등록된 비콘 조회
     */
    return callAPI(ROUTES.TERMINAL.BEACON, 'GET', {}, { corp_no });
}

export const fetchBeaconDetail = (corp_no) => {
    /**
     * 등록된 비콘 조회
     */
    return callAPI(ROUTES.TERMINAL.BEACON.DETAIL, 'GET', {}, { companyNo: corp_no });
}

export const createBeacon = (beaconData) => {
    /**
     * 비콘 등록
     */
    return callAPI(ROUTES.TERMINAL.BEACON.WRITE, 'POST', beaconData);
}

export const fetchBeaconByName = (no) => {
    /**
     * 비콘정보 검색
     */
    return callAPI(ROUTES.TERMINAL.BEACON.MODIFY, 'GET', {}, { no });
}

export const updateBeacon = (beaconData) => {
    /**
     * 비콘 업데이트
     */
    return callAPI(ROUTES.TERMINAL.BEACON.MODIFY_DATA, 'POST', beaconData);
}

export const deleteBeacon = (no) => {
    /**
     * 비콘 업데이트
     */
    return callAPI(ROUTES.TERMINAL.BEACON.MODIFY_DELETE, 'DELETE', {}, { no });
}

export const fetchMobileList = (corp_no) => {
    /**
     * 등록된 비콘 조회
     */
    return callAPI(ROUTES.TERMINAL.MOBILE, 'GET', {}, { companyNo: corp_no });
}

export const fetchMobileByName = (no) => {
    /**
     * 비콘정보 검색
     */
    return callAPI(ROUTES.TERMINAL.MOBILE.MODIFY, 'GET', {}, { no });
}

export const deleteMobile = (no) => {
    /**
     * 비콘 업데이트
     */
    return callAPI(ROUTES.TERMINAL.MOBILE.DELETE, 'DELETE', {}, { no });
}
